module.exports = __webpack_public_path__ + "static/img/logo1.cc0660a.png";